export const SET_AUTH = "auth/SET_AUTH";
export const RESET_AUTH = "auth/RESET_AUTH";
export const LOGIN_ERROR = "auth/LOGIN_ERROR";
export const LOGOUT_ERROR = "auth/LOGOUT_ERROR";
export const RESET_ERROR = "auth/RESET_ERROR";
